import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Intent } from "@blueprintjs/core";
import SendEmailPanel from "components/Common/SendEmailPanel";
import Toast from 'helpers/toaster';

// Email an invoice to the client, in a side panel (components/Common/SendEmailPanel).
// An invoice synced with QuickBooks is sent through QuickBooks.
@inject("quoteStore", "paymentStore", "invoiceStore", "userStore")
@observer
class SendInvoiceModal extends Component {

  componentDidMount() {
    this.props.userStore.loadQuickbooks();
    let { object } = this.props.invoiceStore.sendPaymentInvoice;
    object.emailSubject = "Invoice [#"+this.props.invoiceStore.invoice.object.attributes.number+"] from "+this.props.invoiceStore.invoice.object.attributes.tenant.name
  }

  handleCloseQuoteInvoiceDialog() {
    this.props.onClose();
  }

  onSent() {
    this.props.onClose();
    Toast.show({ message: "Invoice sent.", intent: Intent.SUCCESS });
  }

  SendInvoiceToEmail() {
    const { invoice } = this.props.invoiceStore;
    const { data } = this.props.userStore.quickbooks;
    const viaQuickBooks = Boolean(invoice && invoice.object && invoice.object.attributes && invoice.object.attributes.synced_with_quickbooks === true);

    if (viaQuickBooks) {
      if (!(data && data.company_name)) {
        Toast.show({ message: "Connect QuickBooks in Settings to send this invoice.", intent: Intent.DANGER });
        return;
      }
      this.props.invoiceStore.SendInvoiceToEmailFromQuickBooks()
        .then(() => this.onSent())
        .catch(() => {
          Toast.show({ message: "Couldn’t send the invoice through QuickBooks. Try again.", intent: Intent.DANGER });
        });
      return;
    }

    this.props.invoiceStore.SendInvoiceToEmail()
      .then(() => this.onSent())
      .catch((error) => {
        const errors = error.response && error.response.data && error.response.data.errors;
        Toast.show({
          message: errors ? [].concat(errors).join(' ') : "Couldn’t send the invoice. Try again.",
          intent: Intent.DANGER,
        });
      });
  }

  onEmailChange = (emails) => {
    this.props.invoiceStore.sendPaymentInvoice.object.emailTo = emails.map((contact) => contact.email);
  }

  render() {
    const { sendPaymentInvoice, invoice } = this.props.invoiceStore;
    const client = invoice.object.attributes && invoice.object.attributes.client;
    return (
      <SendEmailPanel
        isOpen={this.props.isOpen}
        onClose={this.handleCloseQuoteInvoiceDialog.bind(this)}
        what="invoice"
        tone="billing"
        object={sendPaymentInvoice.object}
        contacts={client ? [{ email: client.email, name: client.name }] : []}
        busy={Boolean(sendPaymentInvoice.isLoading)}
        onEmailChange={this.onEmailChange}
        onSend={this.SendInvoiceToEmail.bind(this)}
      />
    )
  }

}

export default SendInvoiceModal;
